<app-feature-tiles-grid>
  <app-device-features-container [header]="'+INSTALLATIONS.INSTALLATION.PANEL.BOILER' | translate">
    <app-feature-tile
      isFullWidth="true"
      feature
      [value]="'+INSTALLATIONS.INSTALLATION.PANEL.NBIOT.LABEL' | translate"
      [label]="'+INSTALLATIONS.INSTALLATION.PANEL.NBIOT.TITLE' | translate"
    ></app-feature-tile>
    <app-feature-tile
      *ngIf="gateway$ | async as gateway"
      isFullWidth="true"
      data-at-nbiot-serial
      feature
      label="{{ (gatewayType$ | async) || translateService.instant('+GENERAL.GATEWAY') }}"
      value="{{ gateway?.serial | dash }}"
    ></app-feature-tile>
  </app-device-features-container>
</app-feature-tiles-grid>
